// extracted by mini-css-extract-plugin
module.exports = {"NewPageWithLogin":"index-module_NewPageWithLogin_VFxHe","loginBtn":"index-module_loginBtn_1LCfy"};